import { FDealType, FOfferType } from '../../../../../../packages/JsonQuery';
import { TLocation } from 'shared/types/location';
import { isNewbuildingsRegion, getRegionId } from 'shared/utils/geo';

export const isNewbuildingsAvailable = (dealType: FDealType, offerType: FOfferType, currentLocation: TLocation) =>
  dealType & FDealType.Any && offerType & FOfferType.Urban && isNewbuildingsRegion(getRegionId(currentLocation));
